import { ChangeRequestClient } from '@src/changeRequest/ChangeRequestClient';
import { CreateChangeRequestFooter } from '@src/changeRequest/CreateChangeRequestFooter';
import { LoadingPage } from '@src/common/components/LoadingPage';
import { PrefilledForm } from '@src/common/utils/form/FormPrefilling';
import { FormFields } from '@src/orders/domain/CheckedFields';
import { EditOrder } from '@src/orders/EditOrder';
import type { EditOrderPage } from '@src/orders/EditOrderProvider';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

export const CreateChangeRequestPage: EditOrderPage = (props) => {
  const { t } = useTranslation();
  const { latestForm, latestFormIsLoading } = useOrderLatestForm({
    orderId: props.order.id,
  });

  if (latestFormIsLoading) {
    return <LoadingPage />;
  }

  if (!latestForm) {
    return <>{t('loadingError')}</>;
  }

  const checkedFields = FormFields.convertToFormFields({
    checkedFields: latestForm.fields,
  });
  return (
    <EditOrder
      {...props}
      defaultValues={PrefilledForm({
        currentEntries: props.defaultValues,
        currentFields: checkedFields.fields,
        trailers: props.trailers,
        tractors: props.tractors,
      })}
      checkedFields={checkedFields}
      permitInstructions={latestForm.permitInstructions}
      onSubmit={() => undefined}
      ActionsFooter={CreateChangeRequestFooter}
    />
  );
};

const useOrderLatestForm = ({ orderId }: { orderId: string }) => {
  const { data, isLoading } = useQuery({
    queryKey: ['getLatestFields', orderId],
    queryFn: () => ChangeRequestClient.getOrderLatestForm(orderId),
  });

  return {
    latestForm: data
      ? {
          fields: data.fields,
          permitInstructions: data.permitInstructions,
        }
      : undefined,
    latestFormIsLoading: isLoading,
  };
};
